import styled from '@emotion/styled';
import { type ButtonProps } from '@mui/material';
import TonalButton from '@/components/TonalButton';

type StyledButtonProps = Omit<ButtonProps, 'fullWidth'> & {
  fullWidth: boolean;
};

const StyledButton = styled(TonalButton)<StyledButtonProps>(
  ({ fullWidth }) => ({
    minWidth: fullWidth ? undefined : 240,
    fontSize: 16,
    textTransform: 'none',
  }),
);

export default StyledButton;
